import {BannersPlanTypeEnum} from 'domain/usecases';
import {PlanTypeEnum} from 'presentation/constants';

export const PRODUCT_TYPE = {
	[PlanTypeEnum.HEALTH]: BannersPlanTypeEnum.HEALTH,
	[PlanTypeEnum.ODONTO]: BannersPlanTypeEnum.ODONTO,
	[PlanTypeEnum.HEALTH_ODONTO]: '',
};
